(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initCarousel(root) {
      if (root.dataset.ccInit === 'true') return;
      root.dataset.ccInit = 'true';

      var track = root.querySelector('[data-cc-track]');
      var prevBtn = root.querySelector('[data-cc-prev]');
      var nextBtn = root.querySelector('[data-cc-next]');
      if (!track) return;

      function scrollAmount() {
        var item = track.querySelector('.category-carousel__item');
        var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '24', 10) || 24;
        var itemWidth = item ? item.getBoundingClientRect().width : track.clientWidth / 2;
        var perView = Math.max(1, Math.round(track.clientWidth / (itemWidth + gap)));
        return (itemWidth + gap) * perView;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft >= maxScroll;
        var hasOverflow = track.scrollWidth > track.clientWidth + 2;

        if (prevBtn) {
          prevBtn.disabled = atStart || !hasOverflow;
          prevBtn.setAttribute('tabindex', atStart || !hasOverflow ? '-1' : '0');
        }
        if (nextBtn) {
          nextBtn.disabled = atEnd || !hasOverflow;
          nextBtn.setAttribute('tabindex', atEnd || !hasOverflow ? '-1' : '0');
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 5) {
          moved = true;
          track.classList.add('is-dragging');
          if (track.setPointerCapture && e.pointerId != null) {
            try { track.setPointerCapture(e.pointerId); } catch (err) {}
          }
        }
        if (moved) track.scrollLeft = startScroll - dx;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        updateArrows();
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      track.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      var rafId = null;
      track.addEventListener('scroll', function () {
        if (rafId) return;
        rafId = window.requestAnimationFrame(function () {
          updateArrows();
          rafId = null;
        });
      }, { passive: true });

      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function loadVideoSources(video) {
      if (video.dataset.ccLoaded === 'true') return;
      video.dataset.ccLoaded = 'true';
      var sources = video.querySelectorAll('source[data-cc-src]');
      for (var i = 0; i < sources.length; i++) {
        var url = sources[i].getAttribute('data-cc-src');
        if (url) sources[i].setAttribute('src', url);
      }
      video.load();
    }

    var videoObserver = null;
    function getVideoObserver() {
      if (videoObserver || !('IntersectionObserver' in window)) return videoObserver;
      videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            loadVideoSources(video);
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.35 });
      return videoObserver;
    }

    function initVideos(scope) {
      var videos = (scope || document).querySelectorAll('video[data-cc-video]');
      if (!videos.length) return;
      var obs = getVideoObserver();
      videos.forEach(function (video) {
        if (video.dataset.ccVideoInit === 'true') return;
        video.dataset.ccVideoInit = 'true';
        // Respect reduced-motion: keep the poster frame, don't autoplay.
        if (prefersReduced) return;
        if (obs) {
          obs.observe(video);
        } else {
          // No IntersectionObserver support: load and play immediately.
          loadVideoSources(video);
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        }
      });
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-cc-root]');
      roots.forEach(initCarousel);
      initVideos(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initCarousel(root) {
      if (root.dataset.csInit === 'true') return;
      root.dataset.csInit = 'true';

      var track = root.querySelector('[data-cs-track]');
      var prevBtn = root.querySelector('[data-cs-prev]');
      var nextBtn = root.querySelector('[data-cs-next]');
      if (!track) return;

      function scrollAmount() {
        var item = track.querySelector('.category-stories__item');
        var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '18', 10) || 18;
        var itemWidth = item ? item.getBoundingClientRect().width : track.clientWidth / 2;
        var perView = Math.max(1, Math.floor(track.clientWidth / (itemWidth + gap)));
        return (itemWidth + gap) * perView;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft >= maxScroll;
        var hasOverflow = track.scrollWidth > track.clientWidth + 2;

        if (prevBtn) {
          prevBtn.disabled = atStart || !hasOverflow;
          prevBtn.setAttribute('tabindex', atStart || !hasOverflow ? '-1' : '0');
        }
        if (nextBtn) {
          nextBtn.disabled = atEnd || !hasOverflow;
          nextBtn.setAttribute('tabindex', atEnd || !hasOverflow ? '-1' : '0');
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 5) {
          moved = true;
          track.classList.add('is-dragging');
          if (track.setPointerCapture && e.pointerId != null) {
            try { track.setPointerCapture(e.pointerId); } catch (err) {}
          }
        }
        if (moved) track.scrollLeft = startScroll - dx;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        updateArrows();
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      track.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      var rafId = null;
      track.addEventListener('scroll', function () {
        if (rafId) return;
        rafId = window.requestAnimationFrame(function () {
          updateArrows();
          rafId = null;
        });
      }, { passive: true });

      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function loadVideoSources(video) {
      if (video.dataset.csLoaded === 'true') return;
      video.dataset.csLoaded = 'true';
      var sources = video.querySelectorAll('source[data-cs-src]');
      for (var i = 0; i < sources.length; i++) {
        var url = sources[i].getAttribute('data-cs-src');
        if (url) sources[i].setAttribute('src', url);
      }
      video.load();
    }

    var videoObserver = null;
    function getVideoObserver() {
      if (videoObserver || !('IntersectionObserver' in window)) return videoObserver;
      videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            loadVideoSources(video);
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.35 });
      return videoObserver;
    }

    function initVideos(scope) {
      var videos = (scope || document).querySelectorAll('video[data-cs-video]');
      if (!videos.length) return;
      var obs = getVideoObserver();
      videos.forEach(function (video) {
        if (video.dataset.csVideoInit === 'true') return;
        video.dataset.csVideoInit = 'true';
        if (prefersReduced) return;
        if (obs) {
          obs.observe(video);
        } else {
          loadVideoSources(video);
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        }
      });
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-cs-root]');
      roots.forEach(initCarousel);
      initVideos(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
